const NAME = "CIRCULAR_PROGRESS";

export default NAME;
